export enum ESearchModalState {
  Tags,
  EmptyTags,
  Suggest,
  EmptySuggest,
  SuggestError,
}
